module.exports = __webpack_public_path__ + "img/ff-bars100-75-0-6401.3f2a5ab5.gif";